// extracted by mini-css-extract-plugin
module.exports = {"root":"AccessResourceRecord_root__3FBOB"};